/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateAddressRequestViewModel } from "../types/CreateAddressRequestViewModel.ts";

export const createAddressRequestViewModelSchema = z.object({
  street: z.string().nullish(),
  zipCode: z.string().nullish(),
  placeNumber: z.string().nullish(),
  neighborhood: z.string().nullish(),
  complement: z.string().nullish(),
  countryId: z.optional(z.number().int()),
  stateId: z.number().int().nullish(),
  cityId: z.number().int().nullish(),
  stateName: z.string().nullish(),
  cityName: z.string().nullish(),
}) as unknown as ToZod<CreateAddressRequestViewModel>;
